module.exports = __webpack_public_path__ + "static/media/walter-head-white.79866288.png";